// This is your test publishable API key.
//const stripe = Stripe("pk_test_51MOB0fHIlwpkRlVeYttn1bz84myibKcYkOm7wEBU3FWAYwapNGbdJJNdc70sH1v9awomIYH3GWc5zf0Bux428LoB00rSMdsl2c");
const stripe = Stripe("pk_live_51MOB0fHIlwpkRlVevsOeIDXKTmIlplYSdMiOoIpEbY490GoASqZ9YFApX1X3nnycGGa8nirINU08fiOGQuyIYg4700Z14IsBsM");

// The items the customer wants to buy
const items = [{ id: "New Pilot Customer" }];

let elements;
//const SERVER = 'http://localhost:8080'; //Development
const SERVER = '/api'; //Production




//document
//  .querySelector("#payment-form")
//  .addEventListener("submit", handleSubmit);

var emailAddress = '';
var custName = '';

function setEmailAddress(emailAdd) {
  emailAddress = emailAdd;
}
function setCustName(custName) {
  custName = custName;
}


// Fetches a payment intent and captures the client secret
async function initialize(uuid) {
  const response = await fetch(SERVER + "/createsetuptintent/" + uuid, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items }),
  });
  console.log("Before calling Secret..:");
  const clientSecret = await response.text();
  //console.log("Client Secret..:" + clientSecret);

  const appearance = {
    theme: 'stripe',
  };
  elements = stripe.elements({ clientSecret, appearance});

  //const linkAuthenticationElement = elements.create("linkAuthentication");
  //linkAuthenticationElement.mount("#link-authentication-element");

  //linkAuthenticationElement.on('change', (event) => {
  //  emailAddress = event.value.email;
  //});

  const paymentElementOptions = {
    layout: "tabs",
  };

  const paymentElement = elements.create("payment", paymentElementOptions);
  paymentElement.mount("#payment-element");

  const options = { mode: 'billing' };
  const addressElement = elements.create('address', options);
  addressElement.mount('#address-element');
}

async function handleSubmit(e) {
  e.preventDefault();
  setLoading(true);

  //const error = await stripe.confirmPayment({
  const error = await stripe.confirmSetup({
    elements,
    confirmParams: {
      // Make sure to change this to your payment completion page
      //return_url: "http://localhost:4200/#/telisubscribe/profile" //Development
      return_url: "https://app.teliiport.com/#/telisubscribe/profile" //Production
    },
    redirect: 'if_required',
  });
  console.log("Return Error..:" + error);
  console.log(error);

  // This point will only be reached if there is an immediate error when
  // confirming the payment. Otherwise, your customer will be redirected to
  // your `return_url`. For some payment methods like iDEAL, your customer will
  // be redirected to an intermediate site first to authorize the payment, then
  // redirected to the `return_url`.
  if (error.type === "card_error" || error.type === "validation_error") {
    showMessage(error.message);
  }

  setLoading(false);
  return error;
}

// Fetches the payment intent status after payment submission
async function checkStatus() {
  const clientSecret = new URLSearchParams(window.location.search).get(
    "payment_intent_client_secret"
  );

  if (!clientSecret) {
    return;
  }

  //const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);
  const { paymentIntent } = await stripe.retrieveSetupIntent(clientSecret);

  switch (paymentIntent.status) {
    case "succeeded":
      showMessage("Success! Your payment method has been saved.");
      break;
    case "processing":
      showMessage("Processing payment details. We'll update you when processing is complete.");
      break;
    case "requires_payment_method":
      showMessage("Failed to process payment details. Please try another payment method.");
      break;
    default:
      showMessage("Something went wrong.");
      break;
  }
}

// ------- UI helpers -------

function showMessage(messageText) {
  const messageContainer = document.querySelector("#payment-message");

  messageContainer.classList.remove("hidden");
  messageContainer.textContent = messageText;

  setTimeout(function () {
    messageContainer.classList.add("hidden");
    messageText.textContent = "";
  }, 4000);
}

// Show a spinner on payment submission
function setLoading(isLoading) {
  if (isLoading) {
    // Disable the button and show a spinner
    //document.querySelector("#submit").disabled = true;
    //document.querySelector("#spinner").classList.remove("hidden");
    //document.querySelector("#button-text").classList.add("hidden");
  } else {
    //document.querySelector("#submit").disabled = false;
    //document.querySelector("#spinner").classList.add("hidden");
    //document.querySelector("#button-text").classList.remove("hidden");
  }
}
